import React from "react";
import s from "./PendingRequests.module.scss";
import TableWrapper from "./local components/TableWrapper";
function PendingRequests() {
  return (
    <div className={s.wrapper}>
      <h3 className={s.title}>Number requests</h3>
      <TableWrapper/>
    </div>
  );
}

export default PendingRequests;
